import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { IBoardExportSettings } from '../../../types/rest/IRestUserBoardMeta';
import { boardSetUserMeta } from './boardSetUserMeta';

export const boardSetExportSettings = (
    boardId: TBoardId,
    exportSettings: IBoardExportSettings
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardSetUserMeta(boardId, { exportSettings }));
    };
    return action;
}
